export const iconFontAwesomeFoodBeveragePlateWheat = (
	<i className="fa-solid fa-plate-wheat"></i>
);
